export default function createRegistryId(containerId, subscriptionId) {
	return `${containerId}-${subscriptionId}`;
}
